import * as React from "react";
import styled, { css } from "styled-components";
import { useTranslation } from "react-i18next";
import { StatCard } from "components/common";
import useHistory from "routing/useHistory";
import DataTieringRoutes from "../Routes";
const CREDENTIAL_PROBLEMS_FILTER_URL = `${DataTieringRoutes.WARM_TIER_REPOSITORIES}?filters=credential_status%3Dmissing&filters=credential_status%3Dinvalid`;
const StatsRow = styled.div(
  ({ theme }) => css`
    display: flex;
    margin-bottom: ${theme.spacings.lg};
    gap: ${theme.spacings.md};
    flex-wrap: wrap;
  `
);
const WarmTierCounters = ({
  searchRoleNodeCount,
  availableBackendsCount,
  configuredCount,
  credentialProblemsCount
}) => {
  const { t } = useTranslation("enterprise_data_tiering");
  const history = useHistory();
  return /* @__PURE__ */ React.createElement(StatsRow, null, /* @__PURE__ */ React.createElement(
    StatCard,
    {
      value: searchRoleNodeCount,
      label: t("counters.search_role_nodes"),
      helpText: t("counters.search_role_nodes_help")
    }
  ), /* @__PURE__ */ React.createElement(
    StatCard,
    {
      value: availableBackendsCount,
      label: t("counters.available_plugins"),
      helpText: t("counters.available_plugins_help")
    }
  ), /* @__PURE__ */ React.createElement(
    StatCard,
    {
      value: configuredCount,
      label: t("counters.configured_repositories"),
      helpText: t("counters.configured_repositories_help")
    }
  ), /* @__PURE__ */ React.createElement(
    StatCard,
    {
      value: credentialProblemsCount,
      label: t("counters.credential_problems"),
      helpText: t("counters.credential_problems_help"),
      variant: "warning",
      onClick: () => history.push(CREDENTIAL_PROBLEMS_FILTER_URL)
    }
  ));
};
export default WarmTierCounters;
